const getImage = (assets, imageName) => assets.find(({ basename }) => basename === imageName);

export default getImage;
